import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiDropType } from "@/generated/models/ObjectSerializer";
import { SingleWaveDropPosition } from "./SingleWaveDropPosition";
import { SingleWaveDropContent } from "./SingleWaveDropContent";
import { MemesSingleWaveDropContent } from "./MemesSingleWaveDropContent";
import { WinnerBadge } from "./WinnerBadge";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
interface SingleWaveDropInfoContentProps {
  readonly drop: ExtendedDrop | undefined;
}
export const SingleWaveDropInfoContent: React.FC<SingleWaveDropInfoContentProps> = t0 => {
  const $ = _c(19);
  const {
    drop
  } = t0;
  const {
    isMemesWave
  } = useSeizeSettings();
  if (!drop) {
    return null;
  }
  let t1;
  if ($[0] !== drop.wave.id || $[1] !== isMemesWave) {
    t1 = isMemesWave(drop.wave.id);
    $[0] = drop.wave.id;
    $[1] = isMemesWave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isMemes = t1;
  let t2;
  if ($[3] !== drop.drop_type || $[4] !== drop.rank) {
    t2 = drop?.drop_type === ApiDropType.Participatory && <SingleWaveDropPosition rank={drop.rank} />;
    $[3] = drop.drop_type;
    $[4] = drop.rank;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== drop) {
    t3 = drop.drop_type === ApiDropType.Winner && <WinnerBadge drop={drop} showBadge={true} />;
    $[6] = drop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="tw-px-6 tw-w-full"><div className="tw-flex tw-items-center tw-justify-between"><div>{t2}{t3}</div></div></div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== drop || $[12] !== isMemes) {
    t5 = drop && isMemes ? <MemesSingleWaveDropContent drop={drop} /> : drop && <SingleWaveDropContent drop={drop} />;
    $[11] = drop;
    $[12] = isMemes;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <div className="tw-flex-1 tw-w-full"><div className="tw-px-6">{t5}</div></div>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-y-4">{t4}{t6}</div>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};